// LinkResolver.js file

exports.linkResolver = (doc) => {
  if (doc.type === "media_centre_article_page") {
    return `/media-centre/${doc.uid}`;
  }
  return "/";
};
